<mat-dialog-content class="dialog-scroll-wrapper"
    style="background-color: rgb(247, 248, 250);scrollbar-width:none !important;margin: 0px !important;">

    <div style="text-align: end;transform: translate(8px, -6px);">
        <span class="modal-close" (click)="closeDialog()" style="cursor: pointer;"><i
                class="material-icons">close</i></span>
    </div>

    <div style="display: flex; flex-direction: column; gap: 20px; flex: 1">
        <section class="job-promoter-box" *ngIf="data?.ebanner?.url">
            <img alt="" class="" [src]="data?.ebanner?.url" />

        </section>

        <main class="job-details-content">
            <div class="job-details-container">
                <div class="job-header-new">
                    <div class="job-header-new__left">
                        <div class="job-header-logo">
                            <img *ngIf="data?.elogo?.url" class="job-header-new__avatar" [src]="data?.elogo?.url" />
                        </div>
                        <div>

                            <div *ngIf="data?.ecompanyname">
                                <div class="job-header-new__label">Company Name</div>
                                <div class="job-header-new__company">
                                    {{ data?.ecompanyname }}
                                </div>
                            </div>

                            <div *ngIf="data?.jobtitle">
                                <div class="job-header-new__label">Job title</div>
                                <div class="job-header-new__title">
                                    {{ data?.jobtitle }}
                                </div>
                            </div>
                            <div *ngIf="data?.erole">
                                <div class="job-header-new__label">Role</div>
                                <div class="job-header-new__title">
                                    {{ data?.erole }}
                                </div>
                            </div>



                        </div>
                    </div>

                </div>
                <div class="job-header-new__badges" *ngIf="data?.typeofemp?.length">
                    <span class="job-header-new__badge" *ngFor="let type of data?.typeofemp">{{ type }}</span>
                </div>
            </div>
            <hr class="job-header-new__divider" />

            <div class="job-info-new">
                <div class="job-info-new__item" *ngIf="data?.education">
                    <div class="job-info-new__label">Education Level</div>
                    <div class="job-info-new__value">
                        {{ data?.education }}
                    </div>
                </div>
                <div class="job-info-new__item" *ngIf="data?.erangemin || data?.erangemin ">
                    <div class="job-info-new__label">Pay</div>
                    <div class="job-info-new__value">
                        <span *ngIf="data?.erangemin">{{ data?.erangemin }} </span> - <span *ngIf="data?.erangemax"> {{
                            data?.erangemax }}</span>
                    </div>
                </div>
                <div class="job-info-new__item" *ngIf="data?.hiring_period || data?.ehirequick">
                    <div class="job-info-new__label">Looking for hire</div>
                    <div class="job-info-new__value">
                        {{ data?.hiring_period || data?.ehirequick }}
                    </div>
                </div>
                <div class="job-info-new__item" *ngIf="data?.experience">
                    <div class="job-info-new__label">Experience Level</div>
                    <div class="job-info-new__value">
                        {{ data?.experience }}
                    </div>
                </div>
                <div class="job-info-new__item" *ngIf=" data?.ebilling">
                    <div class="job-info-new__label">Rate</div>
                    <div class="job-info-new__value">
                        {{ data?.ebilling }}
                    </div>
                </div>
                <div class="job-info-new__item" *ngIf="data?.enopeople">
                    <div class="job-info-new__label">No. Positions</div>
                    <div class="job-info-new__value">
                        {{ data?.enopeople }}
                    </div>
                </div>
            </div>
            <hr class="job-header-new__divider" />

            <div class="job-description" *ngIf="data?.ejobdesp">
                <div class="heading">Job Description</div>
                <p>{{ data?.ejobdesp }}</p>
                <hr class="job-header-new__divider" />
            </div>

            <div class="job-location" *ngIf="data?.elocation" style="position: relative;">
                <div>
                    <div class="heading">Job Location</div>
                    <p>{{ data?.elocation }}</p>
                </div>
                <div class="viewmap">
                    <img src="assets/images/social/MapImage.png" alt=""
                        style="width:100%; height:100%; object-fit:cover;">
                    <button type="button" class="view-map-btn" (click)="openMap()">View on map</button>
                </div>

                <div class="map-popup" *ngIf="showMap" (click)="onOutsideClick($event)">
                    <div class="map-content" (click)="$event.stopPropagation()">
                        <div id="map"></div>
                    </div>
                </div>

            </div>
            <hr *ngIf="data?.elocation" class="job-header-new__divider" />


            <div class="about-company" *ngIf="data.aboutCompanyData?.description">
                <div>About Company</div>
                <p [innerHTML]="data.aboutCompanyData?.description"></p>

                <nav *ngIf="data?.website">
                    <span>For more info visit : </span>
                    <a [href]="formatUrl(data?.website)" target="_blank">{{ formatUrl(data?.website)}}</a>
                </nav>

                <hr class="job-header-new__divider" />
            </div>

            <!-- <div class="social-media-row"> -->
            <div class="social-media-row" *ngIf="
                (visibleImages && visibleImages.length > 0) ||
                hasSocialMediaLinks()
              ">
                <div class="social-media-row__item" *ngIf="visibleImages && visibleImages.length > 0">
                    <div class="social-media-row__label">Gallery</div>
                    <div class="gallery-thumbs">
                        <ng-container *ngFor="let image of visibleImages; let i = index">
                            <div class="image-wrapper" style="position: relative; display: inline-block">
                                <img [src]="image?.url" alt="" (click)="openModal(i)" style="cursor: pointer" />
                                <div *ngIf="i === 3 && remainingCount > 0" class="gallery-more-overlay"
                                    (click)="openModal(i)">
                                    +{{ remainingCount }}
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="modal" *ngIf="isModalOpen">
                        <div class="modal-box">
                            <span class="close-btn" (click)="closeModal()">&times;</span>
                            <img [src]="currentImage" alt="" />
                            <button class="prev" (click)="prevImage()">❮</button>
                            <button class="next" (click)="nextImage()">❯</button>
                        </div>
                    </div>
                </div>

                <div class="social-media-row__item" *ngIf="  data?.facebook || data?.instagram ||data?.linkedin"
                    style="margin-left: auto">

                    <div class="social-media-row__label">Social Media Handles</div>
                    <ul class="social-icons">
                        <li *ngIf="data?.facebook">
                            <a [href]="formatUrl(data?.facebook)" target="_blank" rel="noopener">
                                <img src="../../../../../../../assets/images/social/facebook1.png" alt="Facebook" />
                            </a>
                        </li>
                        <li *ngIf="data?.instagram">
                            <a [href]=" formatUrl(data?.instagram)" target="_blank" rel="noopener">
                                <img src="../../../../../../../assets/images/social/Instagram1.png" alt="Instagram" />
                            </a>
                        </li>
                        <li *ngIf="data?.linkedin">
                            <a [href]=" formatUrl(data?.linkedin)" target="_blank" rel="noopener">
                                <img src="../../../../../../../assets/images/social/LinkedIn1.png" alt="LinkedIn" />
                            </a>
                        </li>

                    </ul>
                </div>
            </div>

        </main>
    </div>

</mat-dialog-content>